import _defineProperty from "/vercel/16327899/node_modules/@babel/runtime/helpers/esm/defineProperty";

/**
 * The component style can either be a style object or  a function that returns a
 * style object.
 */
export function mode(light, dark) {
  return function (props) {
    return props.colorMode === "light" ? light : dark;
  };
}
export function orientation(horizontal, vertical) {
  return function (props) {
    return props.orientation === "horizontal" ? horizontal : vertical;
  };
}
export function orient(options) {
  var orientation = options.orientation,
      vertical = options.vertical,
      horizontal = options.horizontal;
  if (!orientation) return {};
  return orientation === "vertical" ? vertical : horizontal;
}
/**
 * Copies the styles from a component sizes or variants to another component
 * under a speicifed key.
 *
 * @param source The component theme object to copy
 * @param component The component string to copy to
 */

export function copy(source, component) {
  var result = {};

  var _loop = function _loop(k) {
    var value = source[k];

    if (typeof value === "function") {
      result[k] = function (props) {
        return _defineProperty({}, component, value(props));
      };
    } else {
      result[k] = _defineProperty({}, component, value);
    }
  };

  for (var k in source) {
    _loop(k);
  }

  return result;
}